import { MapPin } from "lucide-react";
import { fmtDate } from "@/lib/format";

const dateOf = (m) => m.completed_date ?? m.failed_date ?? m.date ?? m.exam_date ?? m.created_at;

export const ModuleList = ({ items, tone, prefix }) => (
  <ul className="space-y-2">
    {items.map((m) => (
      <li key={m.id} className="flex items-center gap-3 rounded-md bg-[#0f172a] p-3" data-testid={`${prefix}-item-${m.id}`}>
        <span className={`shrink-0 rounded px-2 py-1 font-mono text-xs ${tone}`}>{m.module}</span>
        <div className="min-w-0 flex-1 text-xs">
          <p className="text-slate-200 truncate">{m.module_name || m.module}</p>
          <p className="mt-0.5 flex flex-wrap items-center gap-x-3 text-slate-500">
            <span>{fmtDate(dateOf(m))}</span>
            {m.location && <span className="flex items-center gap-1"><MapPin className="h-3 w-3" />{m.location.trim()}</span>}
            {m.score != null && <span className="font-mono">{m.score}%</span>}
          </p>
          {m.notes && <p className="mt-1 text-slate-400">{m.notes}</p>}
        </div>
      </li>
    ))}
  </ul>
);
